import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { createContext, useContext } from "react";
import { Grid } from "./Grid";
export const breadcrumbsGroupClasses = {
    root: "MinervaBreadcrumbsGroup-root",
};
export const BreadcrumbsGroupContext = createContext({
    value: undefined,
});
export const BreadcrumbsGroup = ({ value, className, ...rest }) => {
    return (_jsx(BreadcrumbsGroupContext.Provider, { value: { value }, children: _jsx(Grid, { container: true, gap: 2, className: clsx([breadcrumbsGroupClasses.root, className]), ...rest }) }));
};
export const useBreadcrumbsGroupContext = () => {
    const context = useContext(BreadcrumbsGroupContext);
    return context.value;
};
//# sourceMappingURL=BreadcrumbsGroup.js.map